import React from 'react';

type PostAuthenticationRedirectValue = {
  successUrl: string;
  errorUrl: string;
};

const PostAuthenticationRedirectContext = React.createContext<Nullable<PostAuthenticationRedirectValue>>(null);

export const PostAuthenticationRedirectProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: PostAuthenticationRedirectValue;
}) =>
  React.createElement(PostAuthenticationRedirectContext.Provider, {
    value,
    children,
  });

export const usePostAuthenticationRedirectUrl = () => {
  const value = React.useContext(PostAuthenticationRedirectContext);

  if (!value) {
    throw new Error('Post-authentication redirect is missing');
  }

  return value.successUrl;
};

export const useAuthenticationErrorRedirectUrl = () => {
  const value = React.useContext(PostAuthenticationRedirectContext);

  if (!value) {
    throw new Error('Authentication error redirect is missing');
  }

  return value.errorUrl;
};
